
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    url: { type: [String, Object], required: false, default: undefined },
    target: { type: String, required: false, default: undefined },
    label: { type: [String, Object], required: false, default: undefined },
    text: { type: [String, Object], required: false, default: undefined },
    semantic: { type: Number, required: false, default: 4 },
    download: { type: Boolean, required: false, default: false },
  },
})
